@let memberValue = member();

<div class="member">
  <div class="member-details">
    <rt-avatar
      class="member-avatar"
      size="small"
      [type]="!!memberValue.avatarThumbUrl ? 'image' : 'initials'"
      [imageSrc]="memberValue.avatarThumbUrl"
      [fullName]="memberFullName()"
      context="admin"
    />
    <div class="member-name">
      <div class="name-wrapper">
        <rt-heading class="member-name-heading">
          <rt-truncate>{{ memberFullName() }}</rt-truncate>
        </rt-heading>
      </div>
      @if (memberValue.hasWorkEmail && memberValue.email) {
        <span class="email"
          ><rt-truncate>{{ memberValue.email }}</rt-truncate></span
        >
      } @else if (!memberValue.hasWorkEmail && memberValue.login) {
        <span class="email"
          ><rt-truncate>{{ memberValue.login }}</rt-truncate></span
        >
      }
    </div>
  </div>
  <div class="buttons-container">
    @if (canViewHistory()) {
      <rt-button variant="plain" (click)="viewHistory.emit(memberValue.guid)">
        <rt-icon name="history" />
        <span class="action-label">{{ 'tlc.common.history' | translate }}</span>
      </rt-button>
    }
    <rt-button class="view-member" variant="plain" (click)="viewMember.emit(memberValue.guid)">
      <rt-icon name="open-in-new" />
      <span class="action-label">{{ 'tlc.common.view' | translate }}</span>
    </rt-button>
    @if (canUnassign()) {
      <rt-button variant="plain" (click)="unassignMember.emit(memberValue)">
        <rt-icon name="close" />
        <span class="action-label">{{ 'tlc.common.remove' | translate }}</span>
      </rt-button>
    }
  </div>
</div>
